import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { SearchHistoryModel } from '@/core/History/model/SearchHistoryModel.js';
/**
 * @method apiGetPointHistory
 * @method apiExpirePoint
 */
export default {
    
    /**
     * @param {Object} params HistoryPointConfigModel - /core/Point/config/PointConfigModel.js
     */
    apiGetPointLog: function (params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/log/points';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let list = [];
            for (let item of res.data) {
                let history = new SearchHistoryModel (item);
                list.push(history);
            }
            return list;
        }));
    },
    /**
     * @param {Object} params HistoryPointConfigModel - /core/Point/config/PointConfigModel.js
     */
    apiGetPointHistory: function (params) {
        const token = Account.getToken();
        //let token = ".MWNAp0PSR4c74KWPEZxgY6Zp9P3UmTs6fvIx2taqK45ycJinZSJASChSph09mE82P102eCH8M87cBlchEI2gxS5iNq10dvwVPrGb4ITBWdggs-jFuvMBZ-2DutH7XKj49NuLzwar7Vx9SGDBrwohYy1M7M2wBwpGYC7AXzeEbtjub-2qRMdTTARjq-DqOo8g"
        //const url = ConfigManager.getApiUrl() + '/log/points';
        const url = ConfigManager.getApiModuleUrl() + '/point/transfer_log';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            let list = []; 
            for (let item of res.data.data) {
                let history = new SearchHistoryModel (item);
                list.push(history);
            }
            return list;
        }));
    },
    apiExpirePoint: function () {
        const token = Account.getToken();
        const url = ConfigManager.getApiUrl() + '/log/points';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map(res => res.data));
    },
}
